import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { publicApi } from "@/lib/api";
import { SectionHeading, PressCard, Loader } from "@/components/public/ui";

export default function Press() {
  const [press, setPress] = useState(null);
  useEffect(() => { publicApi.get("/press").then((r) => setPress(r.data)).catch(() => setPress([])); }, []);

  const featured = press?.find((p) => p.featured);
  const rest = (press || []).filter((p) => !p.featured);
  const awards = rest.filter((p) => p.type === "award");
  const articles = rest.filter((p) => p.type !== "award");

  return (
    <div className="pt-20">
      <section className="bg-[#18344A] py-20 text-white">
        <div className="mx-auto max-w-[1280px] px-5 lg:px-8">
          <SectionHeading eyebrow="Media Center" title="Press & Accolades" light
            intro="Stories, recognition and news from across the Pack Brothers Hospitality collection." />
        </div>
      </section>

      {press === null ? <div className="py-20"><Loader /></div> : (
        <div className="mx-auto max-w-[1280px] px-5 py-16 lg:px-8">
          {featured && (
            <a href={featured.url || undefined} target={featured.url ? "_blank" : undefined} rel="noreferrer"
              className="mb-14 block rounded-2xl border border-[var(--pb-border)] bg-white p-8 transition-shadow hover:shadow-[0_20px_50px_rgba(24,52,74,0.12)] md:p-12">
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[#526E7E]">Featured · {featured.publication}</p>
              <h2 className="mt-3 max-w-3xl font-serif text-[32px] leading-tight text-[#18344A] sm:text-[42px]">{featured.headline}</h2>
              {featured.excerpt && <p className="mt-4 max-w-2xl text-[15px] text-[rgba(48,56,60,0.72)]">{featured.excerpt}</p>}
              {featured.url && <span className="mt-5 inline-block text-sm font-semibold text-[#18344A]">Read the Story →</span>}
            </a>
          )}

          {articles.length > 0 && (
            <>
              <h3 className="mb-6 font-serif text-2xl text-[#18344A]">Latest Coverage</h3>
              <div className="mb-14 grid gap-6 md:grid-cols-3">{articles.map((p) => <PressCard key={p.id} p={p} />)}</div>
            </>
          )}

          {awards.length > 0 && (
            <>
              <h3 className="mb-6 font-serif text-2xl text-[#18344A]">Awards & Recognition</h3>
              <div className="grid gap-6 md:grid-cols-3">{awards.map((p) => <PressCard key={p.id} p={p} />)}</div>
            </>
          )}

          <div className="mt-16 rounded-2xl bg-[#F5F3EF] p-8 text-center">
            <h3 className="font-serif text-2xl text-[#18344A]">Media Inquiries</h3>
            <p className="mt-2 text-sm text-[rgba(48,56,60,0.7)]">For interviews, imagery or press questions, we'd love to help.</p>
            <Link to="/contact" className="mt-5 inline-flex rounded-full bg-[#18344A] px-6 py-3 text-sm font-semibold uppercase tracking-[0.06em] text-white hover:bg-[#18344A]/90">Contact Press</Link>
          </div>
        </div>
      )}
    </div>
  );
}
